"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.generateGutter = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoize = _interopRequireDefault(require("@guestyci/memoize"));

var _commonUtility = require("../../utils/commonUtility");

var _createStyles = _interopRequireDefault(require("../../createStyles"));

var _styles = _interopRequireDefault(require("../styles"));

var _utils = require("../../utils");

var _excluded = ["bgColor", "className", "style", "children", "gutter", "flex", "wrap", "justify", "align", "jss"];
var generateGutter = (0, _memoize["default"])(function (gutter, spacer) {
  if (!gutter) {
    return undefined;
  }

  if ((0, _utils.isNumber)(gutter)) {
    return spacer(gutter);
  }

  return gutter.split(' ').reduce(function (padding, item) {
    return "".concat(padding, " ").concat(spacer(item), "px");
  }, '').trim();
});
exports.generateGutter = generateGutter;
var useStyles = (0, _createStyles["default"])(function (theme) {
  return (0, _extends2["default"])({
    root: {
      backgroundColor: function backgroundColor(_ref) {
        var bgColor = _ref.bgColor;
        return bgColor;
      }
    },
    gutter: {
      padding: function padding(_ref2) {
        var gutter = _ref2.gutter;
        return generateGutter(gutter, theme.spacer);
      }
    },
    displayFlex: {
      display: 'flex',
      width: '100%'
    }
  }, _styles["default"]);
}, {
  name: 'Section'
});
exports.useStyles = useStyles;

var Section = /*#__PURE__*/_react["default"].forwardRef(function Section(_ref3, ref) {
  var _cn;

  var _ref3$bgColor = _ref3.bgColor,
      bgColor = _ref3$bgColor === void 0 ? 'initial' : _ref3$bgColor,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? null : _ref3$children,
      _ref3$gutter = _ref3.gutter,
      gutter = _ref3$gutter === void 0 ? 0 : _ref3$gutter,
      _ref3$flex = _ref3.flex,
      flex = _ref3$flex === void 0 ? true : _ref3$flex,
      _ref3$wrap = _ref3.wrap,
      wrap = _ref3$wrap === void 0 ? true : _ref3$wrap,
      _ref3$justify = _ref3.justify,
      justify = _ref3$justify === void 0 ? 'start' : _ref3$justify,
      _ref3$align = _ref3.align,
      align = _ref3$align === void 0 ? 'stretch' : _ref3$align,
      jss = _ref3.jss,
      props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var classes = useStyles({
    bgColor: bgColor,
    gutter: gutter,
    jss: jss
  });
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.gutter, gutter), (0, _defineProperty2["default"])(_cn, classes.flexWrap, wrap), (0, _defineProperty2["default"])(_cn, classes.displayFlex, flex), (0, _defineProperty2["default"])(_cn, classes["justify".concat((0, _commonUtility.firstLetterUppercase)(justify))], justify !== 'start'), (0, _defineProperty2["default"])(_cn, classes["alignItems".concat((0, _commonUtility.firstLetterUppercase)(align))], align !== 'stretch'), _cn), className),
    style: style
  }), children);
}); // Hack for withInfo plugin


Section.displayName = 'Section';
var _default = Section;
exports["default"] = _default;